import { render } from "./DotThird.vue?vue&type=template&id=7d4ee40a&scoped=true"
import script from "./DotThird.vue?vue&type=script&lang=js"
export * from "./DotThird.vue?vue&type=script&lang=js"

import "./DotThird.vue?vue&type=style&index=0&id=7d4ee40a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d4ee40a"]])

export default __exports__